// LimitText Class
import { LimitText } from "../classes/LimitText";
// i18next Localization library
import i18next from "i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Moment js for dates and datepicker
import * as moment from 'moment/moment';
import "daterangepicker/daterangepicker";


const cardsParagraph = document.querySelectorAll(".news-cards .card p.card-text");

function replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(10), "g");
    return str.trim().replace(re, "<br>");
}

cardsParagraph.forEach( (paragraph) => {
    let limit = 150;
    let inputText = paragraph.innerHTML;
    if ( inputText.length > limit ) {
        let limit_Text_size = new LimitText(inputText, limit);
        paragraph.innerHTML = limit_Text_size.limitOutput;
    }
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});

const news_list = document.querySelectorAll('#news-cards .news');
const news_active_list = $('#news-cards .newsList.active .news');
const order_dd_menu = $('#news .sortby').find('.dropdown-menu');
const order_dd_toggler = $('#news .sortby').find('.dropdown-toggle');

// Show active order switch case (UMBRACO)
function newsActiveOrder(activeOrder){
    switch(activeOrder){
        case '#ascending':
            $('#news-cards .newsListAsc').addClass('active');
            break;
        case '#descending':
            $('#news-cards .newsListDesc').addClass('active');
            break;
        default:
            $('#news-cards .newsListAsc').addClass('active');
            break;
    }
}

$(function(){

    // ON PAGE LOAD EVENT
    const culture = document.documentElement.lang.substr(0,2);
    if($('input[name="daterange"]').length > 0){
        const newsDatesArr = []; 
        for(let i=0; i < $('.newsList .news').length; i++){
            const newsDate = $('.newsList .news').eq(i).find('.news-date').text();
            newsDatesArr.push(new Date(newsDate.toString()));
        };
        const maxDate = new Date(Math.max.apply(null, newsDatesArr));
        const minDate = new Date(Math.min.apply(null, newsDatesArr));
        // //console.log(minDate, maxDate);
        // Initialize date range picker
        $('input[name="daterange"]').daterangepicker({
            "showDropdowns": true,
            "maxYear": new Date().getFullYear,
            "autoApply": true,
            "maxSpan": false,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            "locale": {
                "format": "DD MMMM YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "W",
                "daysOfWeek": [
                    "Sa",
                    "Su",
                    "Mo",
                    "Tu",
                    "We",
                    "Th",
                    "Fr",
                ],
                "monthNames": [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                "firstDay": 1
            },
            "startDate": moment(minDate).format('DD MMMM YYYY'),
            "endDate": moment(maxDate).format('DD MMMM YYYY'),
            "maxDate": new Date(),
            "opens": "center",
            "drops": "auto"
        }, function(start, end, label) {
            //console.log('New date range selected: ' + start.format('DD MMMM YYYY') + ' to ' + end.format('DD MMMM YYYY') + ' (predefined range: ' + label + ')');
        });

        // On applying Date Range
        $('input[name="daterange"]').on('apply.daterangepicker', function(ev, picker) {
            const startDate = picker.startDate.format('DD MMMM YYYY');
            const endDate = picker.endDate.format('DD MMMM YYYY');
            // //console.log(startDate, endDate);
            for(let i=0; i < $('.newsList .news').length; i++){
                const newsDate = $('.newsList .news').eq(i).find('.news-date').text();
                // //console.log(new Date(startDate.toString()), new Date(newsDate.toString()), new Date(endDate.toString()));
                if( (new Date(startDate.toString()) <= new Date(newsDate.toString())) && (new Date(newsDate.toString()) <= new Date(endDate.toString())) ){
                    $('.newsList .news').eq(i).show().addClass('active');
                }else{
                    $('.newsList .news').eq(i).hide().addClass('inactive');
                }
            };
        });
    }
    
    async function initI18next() {
        await i18next
          .use(HttpApi)
          .use(LanguageDetector)
          .init({
            debug: true,
            supportedLngs: ["en", "ar"],
            fallbackLng: "en",
            nonExplicitSupportedLngs: false,
            backend: {
              loadPath: "/dist/lang/{{lng}}.json",
            },
          });
      }

    // // Hide all news list THEN show only the correct order according to item 'news-order'
    // $('#news-cards .newsList').removeClass('active');
    (async function () {
        await initI18next();
        i18next
        .changeLanguage(culture);
        // Clear order active selection
        order_dd_menu.find('.dropdown-item').removeClass('active');
        // Check for session storage item (news-order) value
        // If not found activate the first choice
        // Else activate the found item 'news-order' value
        if(sessionStorage.getItem('news-order') === null){
            // Activate the default order
            order_dd_menu.find('li').eq(0).find('.dropdown-item').addClass('active');
            order_dd_toggler.text(order_dd_menu.find('li').eq(0).find('.dropdown-item').text());
            // Set item to default order value
            sessionStorage.setItem('news-order', order_dd_menu.find('li').eq(0).find('.dropdown-item').attr('href'));
            order_dd_toggler.text( i18next.t(order_dd_menu.find('li').eq(0).find('.dropdown-item').attr('data-i18n-key')) );
            
        }else{
            // loop over order dropdown items
            for( let i=0; i < order_dd_menu.find('li').length; i++ ){
                // Compare to item 'news-order'
                if(order_dd_menu.find('li').eq(i).find('.dropdown-item').attr('href') === sessionStorage.getItem('news-order')){
                    // Activate the corresponding dropdown item
                    order_dd_menu.find('li').eq(i).find('.dropdown-item').addClass('active');
                    order_dd_toggler.text(order_dd_menu.find('li').eq(i).find('.dropdown-item').text());
                    order_dd_toggler.text( i18next.t(order_dd_menu.find('li').eq(i).find('.dropdown-item').attr('data-i18n-key')) );
                }
            }
        }
    })();
    
    

    // Sort according to session storage
    let orderBy = sessionStorage.getItem('news-order');
    newsActiveOrder(orderBy);


    // EVENT HANDLER
    // Change order selection
    order_dd_menu.find('.dropdown-item').on('click', (e) => {
        e.preventDefault();

        const selected_item = $(e.currentTarget);
        order_dd_menu.find('.dropdown-item').removeClass('active');
        selected_item.addClass('active');
        order_dd_toggler.text(selected_item.text());

        sessionStorage.setItem('news-order', selected_item.attr('href').toLowerCase());
        $('#news-cards .newsList').removeClass('active');
        // Show only active order
        orderBy = sessionStorage.getItem('news-order');
        newsActiveOrder(orderBy);
    });
    
});